import { Button } from "@/shared/ui/form/Button";

interface CatalogLoadMoreProps {
  errorMessage?: string | null;
  hasNextPage: boolean;
  isFetching: boolean;
  onLoadMore: () => void;
}

/** SP版カタログの次ページを末尾へ追記する操作を表示する。 */
export function CatalogLoadMore({
  errorMessage,
  hasNextPage,
  isFetching,
  onLoadMore,
}: CatalogLoadMoreProps): React.ReactElement {
  const label = isFetching
    ? "読み込み中…"
    : hasNextPage
      ? "もっと表示"
      : "すべて表示しました";

  return (
    <section
      aria-label="カタログの追加読み込み"
      className="flex flex-col items-center px-4 py-4"
      aria-busy={isFetching}
      aria-live="polite"
    >
      {errorMessage && (
        <p className="mb-2 text-sm text-destructive" role="alert">
          {errorMessage}
        </p>
      )}
      <Button
        variant="secondary"
        className="min-h-11 min-w-40"
        disabled={isFetching || !hasNextPage}
        onClick={onLoadMore}
      >
        {label}
      </Button>
    </section>
  );
}
